import React from 'react';
import { Box, Typography } from '@material-ui/core';

import useStyles from './styles';

const ContextBar = props => {
  const classes = useStyles();
  const { title, children } = props;

  return (
    <Box className={classes.container}>
      <Typography className="title" variant="subtitle2">
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default ContextBar;
